import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

import { IntroGuard } from './guards/intro.guard';
import { AutoLoginGuard } from './guards/auto-login.guard';

const routes: Routes = [
/**/ {
    path: '',
    redirectTo: '/intro',
    pathMatch: 'full'
  }, 
 {
    path: 'intro',
    loadChildren: () => import('./pages/intro/intro.module').then( m => m.IntroPageModule)
  },
  {
    path: 'login',
    loadChildren: () => import('./pages/login/login.module').then( m => m.LoginPageModule),
    canLoad: [IntroGuard, AutoLoginGuard] // Check if we should show the introduction or forward to inside
  },
    {
      path: 'app',
      loadChildren: () => import('./pages/tabs-page/tabs-page.module').then(m => m.TabsModule)
    },
  {
    path: 'registration',
    loadChildren: () => import('./pages/registration/registration.module').then( m => m.RegistrationPageModule)
  },
  {
    path: 'registration/:club',
    loadChildren: () => import('./pages/registration/registration.module').then( m => m.RegistrationPageModule)
  },
  {
    path: 'public/survey/:token',
    loadComponent: () => import('./pages/public-survey/public-survey.page').then(m => m.PublicSurveyPage)
  },
  {
    path: 'public/membership/:token',
    loadComponent: () => import('./pages/public-membership/public-membership.page').then(m => m.PublicMembershipPage)
  }



  ];
  
  @NgModule({
    imports: [
      RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
    ],
    exports: [RouterModule]
  })
  export class AppRoutingModule {}
  
